import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCalendar';
/** Renders an SVG icon. */
const SvgCalendar = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7 26a1 1 0 0 1-1-1V14h20v11a1 1 0 0 1-1 1zm19-14H6V9a1 1 0 0 1 1-1h3v1a1 1 0 1 0 2 0V8h8v1a1 1 0 1 0 2 0V8h3a1 1 0 0 1 1 1zm-4-6h3a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h3V5a1 1 0 1 1 2 0v1h8V5a1 1 0 1 1 2 0zM8 22a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2H9a1 1 0 0 0-1 1m6 0a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1m-6-4a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2H9a1 1 0 0 0-1 1m6 0a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1m6 0a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1"
      />
    </svg>
  );
};
SvgCalendar.displayName = displayName;
export default SvgCalendar;
